import React, { useMemo } from 'react';
import {
    useHistory, useLocation, useRouteMatch,
} from 'react-router';

export const useRouterState = () => {
    const history = useHistory();
    const location = useLocation();
    const match = useRouteMatch();

    const state = useMemo(
        () => ({
            history,
            location,
            match,
        }),
        [history, location, match],
    );

    return [state];
};
